import { useParams } from "next/navigation";
import React from "react";

const CategoryLinks = ({
  data,
  setCategory,
  setSearchTerm,
  postLen,
  setPage,
  showSinglePostCallback,
}) => {
  const { slug } = useParams();
  const handleCategoryClick = (cat_id) => {
    setCategory(cat_id);
    setSearchTerm("");
  };
  return (
    <div className="my-4 text-center text-sm">
      <button
        className="rounded m-2 cursor-pointer"
        onClick={() => {
          setCategory(null);
          setSearchTerm("");
          setPage(1);
          typeof showSinglePostCallback === "function" &&
            showSinglePostCallback();
        }}
      >
        <span className="bg-[#6e2b07] text-white category_name duration-200 px-3 py-1 ">
          सभी
        </span>
        <span className="bg-[#c8d3de] px-2 py-1 text-[#6e2b07]">({postLen})</span>
      </button>

      {data.map((cat) => (
        <button
          className="rounded m-2 cursor-pointer"
          key={cat.cat_id}
          onClick={() => handleCategoryClick(cat.cat_id)}
        >
          <span className="bg-[#c8d3de] category_name duration-200 px-3 py-1 text-[#6e2b07]">
            {cat.cat_name}
          </span>
          <span className="bg-[#6e2b07] px-2 py-1 text-white">
            ({cat.post_count})
          </span>
        </button>
      ))}
    </div>
  );
};

export default CategoryLinks;
